import { TicketAttachmentPayload } from '../../models/ticket.model';

/**
 * Files picked in a ticket form → the base64 payload the integrator takes. The BFF
 * has no multipart path, so files travel inside the JSON body.
 */
export function encodeTicketFiles(files: File[]): Promise<TicketAttachmentPayload[]> {
  return Promise.all(
    files.map(
      (file) =>
        new Promise<TicketAttachmentPayload>((resolve, reject) => {
          const reader = new FileReader();
          reader.onerror = () => reject(reader.error);
          reader.onload = () => {
            // "data:<type>;base64,<data>": keep only the data.
            const url = String(reader.result || '');
            resolve({
              filename: file.name,
              mimeType: file.type || 'application/octet-stream',
              data: url.slice(url.indexOf(',') + 1)
            });
          };
          reader.readAsDataURL(file);
        })
    )
  );
}

/** Hands a downloaded blob to the browser as a file. */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
